import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { VOLOP_WELCOME_TYPE } from '#/utils/constants/general/welcomeOptions';

export function volopWelcomeFacet(i18n: I18nFn) {
  return {
    id: 'volopWelcomeFacet',
    name: 'welcome',
    get title() {
      return i18n('Good For');
    },
    type: 'array',
    options: Object.keys(VOLOP_WELCOME_TYPE(i18n)),
    optionTitles: VOLOP_WELCOME_TYPE(i18n),
    sort: false,
  } as const satisfies SearchFacetData;
}
